import { render, staticRenderFns } from "./the-add-monthly-card.vue?vue&type=template&id=2da60237&scoped=true&"
import script from "./the-add-monthly-card.vue?vue&type=script&lang=js&"
export * from "./the-add-monthly-card.vue?vue&type=script&lang=js&"
import style0 from "./the-add-monthly-card.vue?vue&type=style&index=0&id=2da60237&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da60237",
  null
  
)

export default component.exports